import { gql } from '@apollo/client';
import questionFeedbackFragment from '../fragments/questionFeedbackFragment';

export default gql`
  mutation createFeedback($input: QuestionFeedbackInput) {
    createFeedback(input: $input) {
      ...questionFeedbackFragment
    }
  }
  ${questionFeedbackFragment}
`;
